import { isInViewport } from './../helpers';
export default class AnimateOnScroll {

    constructor(el) {
        if (el) {
            this.el = el;
            window.addEventListener('scroll', () => this.toggleClass());
        }
    }

    toggleClass() {
        if (isInViewport(this.el)) {
            this.el.classList.add('animate-on-scroll--in');
            if (this.el.classList.contains('animate-on-scroll--out')) {
                this.el.classList.remove('animate-on-scroll--out');
            }
        } else {
            this.el.classList.add('animate-on-scroll--out')
            if (this.el.classList.contains('animate-on-scroll--in')) {
                this.el.classList.remove('animate-on-scroll--in');
            }
        }
    }
}